<template>
  <v-navigation-drawer v-model="model" class="matching-sidebar elevation-5" fixed>
    <v-container fluid class="px-1">
      <!-- The pivot selector -->
      <v-layout>
        <v-flex>
          <v-sidebar-pivot />
        </v-flex>
      </v-layout>
      <!-- The button to create the QMP -->
      <v-slide-y-reverse-transition>
        <v-layout
          v-if="showCreateQmpButton && !!pivotItem"
          justify-center
          style="margin-top: -15px"
        >
          <v-flex shrink>
            <!-- A dialog to show the selected items to create the QMP -->
            <v-dialog v-model="showSelectedItems">
              <template #activator="{ on }">
                <v-create-qmp-btn v-on="on" @click="handleClickOnCreateButton" />
              </template>
              <!-- The content with the selected items -->
              <v-selected-items ref="selectedItems" />
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-slide-y-reverse-transition>
      <!-- The filters to apply over the similar items -->
      <v-layout>
        <v-flex>
          <v-divider />
          <v-similar-items-filters />
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

import VCreateQmpBtn from "./CreateQmpBtn";
import VSelectedItems from "./SelectedItems";
import VSidebarPivot from "./SidebarPivot";
import VSimilarItemsFilters from "./SimilarItemsFilters";

export default {
  components: {
    VCreateQmpBtn,
    VSelectedItems,
    VSidebarPivot,
    VSimilarItemsFilters
  },
  data: () => ({
    showCreateQmpButton: false,
    showSelectedItems: false
  }),
  computed: {
    ...mapGetters(["pivotItem"]),
    ...mapState(["loadingPivotItems", "selectedItems", "sidebarVisible"]),
    model: {
      get() {
        return this.sidebarVisible;
      },
      set(val) {
        this.setSidebarVisible(val);
      }
    }
  },
  watch: {
    loadingPivotItems() {
      if (!this.loadingPivotItems) {
        setTimeout(() => {
          this.showCreateQmpButton = true;
        }, 300);
      } else {
        this.showCreateQmpButton = false;
      }
    },
    selectedItems() {
      if (!this.selectedItems.length) {
        this.showSelectedItems = false;
      }
    }
  },
  created() {
    this.model = true;
  },
  methods: {
    ...mapMutations(["setSidebarVisible"]),
    handleClickOnCreateButton() {
      if (this.selectedItems.length) {
        this.showSelectedItems = true;
      } else {
        this.$refs.selectedItems.createProduct();
      }
    }
  }
};
</script>

<style scoped>
.matching-sidebar {
  height: calc(100vh - 64px) !important;
  margin-top: 64px !important;
  z-index: 1;
}
</style>